module.exports = __webpack_public_path__ + "static/img/Registrobr3.867f3da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/faq/Registrobr3.png
// module id = 1770
// module chunks = 5